import { createActions, handleActions } from 'redux-actions'
import idsMatch from 'utils/idsMatch'

export const APPLY_TO_SCHOLARSHIP = 'growsmart/APPLY_TO_SCHOLARSHIP'
export const APPLY_TO_SCHOLARSHIP_SUCCESS = 'growsmart/APPLY_TO_SCHOLARSHIP_SUCCESS'
export const APPLY_TO_SCHOLARSHIP_FAILURE = 'growsmart/APPLY_TO_SCHOLARSHIP_FAILURE'

export const BULK_UPDATE_HARDCOPY_SUBMISSIONS = 'growsmart/BULK_UPDATE_HARDCOPY_SUBMISSIONS'
export const BULK_UPDATE_HARDCOPY_SUBMISSIONS_SUCCESS =
  'growsmart/BULK_UPDATE_HARDCOPY_SUBMISSIONS_SUCCESS'
export const BULK_UPDATE_HARDCOPY_SUBMISSIONS_FAILURE =
  'growsmart/BULK_UPDATE_HARDCOPY_SUBMISSIONS_FAILURE'

export const BULK_UPDATE_SCHOOLS = 'growsmart/BULK_UPDATE_SCHOOLS'
export const BULK_UPDATE_SCHOOLS_SUCCESS = 'growsmart/BULK_UPDATE_SCHOOLS_SUCCESS'
export const BULK_UPDATE_SCHOOLS_FAILURE = 'growsmart/BULK_UPDATE_SCHOOLS_FAILURE'

export const DECLINE_INVITE = 'growsmart/DECLINE_INVITE'
export const DECLINE_INVITE_SUCCESS = 'growsmart/DECLINE_INVITE_SUCCESS'
export const DECLINE_INVITE_FAILURE = 'growsmart/DECLINE_INVITE_FAILURE'

export const FETCH_REGISTRATIONS = 'growsmart/FETCH_REGISTRATIONS'
export const FETCH_REGISTRATIONS_SUCCESS = 'growsmart/FETCH_REGISTRATIONS_SUCCESS'
export const FETCH_REGISTRATIONS_FAILURE = 'growsmart/FETCH_REGISTRATIONS_FAILURE'

export const FETCH_ENROLMENTS = 'growsmart/FETCH_ENROLMENTS'
export const FETCH_ENROLMENTS_SUCCESS = 'growsmart/FETCH_ENROLMENTS_SUCCESS'
export const FETCH_ENROLMENTS_FAILURE = 'growsmart/FETCH_ENROLMENTS_FAILURE'

export const FETCH_ENROLMENT = 'growsmart/FETCH_ENROLMENT'
export const FETCH_ENROLMENT_SUCCESS = 'growsmart/FETCH_ENROLMENT_SUCCESS'
export const FETCH_ENROLMENT_FAILURE = 'growsmart/FETCH_ENROLMENT_FAILURE'

export const FETCH_DISTRICTS = 'growsmart/FETCH_DISTRICTS'
export const FETCH_DISTRICTS_SUCCESS = 'growsmart/FETCH_DISTRICTS_SUCCESS'
export const FETCH_DISTRICTS_FAILURE = 'growsmart/FETCH_DISTRICTS_FAILURE'

export const FETCH_RSVPS = 'growsmart/FETCH_RSVPS'
export const FETCH_RSVPS_SUCCESS = 'growsmart/FETCH_RSVPS_SUCCESS'
export const FETCH_RSVPS_FAILURE = 'growsmart/FETCH_RSVPS_FAILURE'

export const FETCH_SCHOOLS_FOR_PROVINCE = 'growsmart/FETCH_SCHOOLS_FOR_PROVINCE'
export const FETCH_SCHOOLS_FOR_PROVINCE_SUCCESS = 'growsmart/FETCH_SCHOOLS_FOR_PROVINCE_SUCCESS'
export const FETCH_SCHOOLS_FOR_PROVINCE_FAILURE = 'growsmart/FETCH_SCHOOLS_FOR_PROVINCE_FAILURE'

export const INVITE_MENTOR = 'growsmart/INVITE_MENTOR'
export const INVITE_MENTOR_SUCCESS = 'growsmart/INVITE_MENTOR_SUCCESS'
export const INVITE_MENTOR_FAILURE = 'growsmart/INVITE_MENTOR_FAILURE'

export const FETCH_SPONSORSHIP = 'growsmart/FETCH_SPONSORSHIP'
export const FETCH_SPONSORSHIP_SUCCESS = 'growsmart/FETCH_SPONSORSHIP_SUCCESS'
export const FETCH_SPONSORSHIP_FAILURE = 'growsmart/FETCH_SPONSORSHIP_FAILURE'

export const FETCH_SPONSORSHIPS = 'growsmart/FETCH_SPONSORSHIPS'
export const FETCH_SPONSORSHIPS_SUCCESS = 'growsmart/FETCH_SPONSORSHIPS_SUCCESS'
export const FETCH_SPONSORSHIPS_FAILURE = 'growsmart/FETCH_SPONSORSHIPS_FAILURE'

export const DELETE_SPONSORSHIP = 'growsmart/DELETE_SPONSORSHIP'
export const DELETE_SPONSORSHIP_SUCCESS = 'growsmart/DELETE_SPONSORSHIP_SUCCESS'
export const DELETE_SPONSORSHIP_FAILURE = 'growsmart/DELETE_SPONSORSHIP_FAILURE'

export const CREATE_SPONSORSHIP = 'growsmart/CREATE_SPONSORSHIP'
export const CREATE_SPONSORSHIP_SUCCESS = 'growsmart/CREATE_SPONSORSHIP_SUCCESS'
export const CREATE_SPONSORSHIP_FAILURE = 'growsmart/CREATE_SPONSORSHIP_FAILURE'

export const FETCH_SCHOLARSHIP = 'growsmart/FETCH_SCHOLARSHIP'
export const FETCH_SCHOLARSHIP_SUCCESS = 'growsmart/FETCH_SCHOLARSHIP_SUCCESS'
export const FETCH_SCHOLARSHIP_FAILURE = 'growsmart/FETCH_SCHOLARSHIP_FAILURE'

export const FETCH_SCHOLARSHIPS = 'growsmart/FETCH_SCHOLARSHIPS'
export const FETCH_SCHOLARSHIPS_SUCCESS = 'growsmart/FETCH_SCHOLARSHIPS_SUCCESS'
export const FETCH_SCHOLARSHIPS_FAILURE = 'growsmart/FETCH_SCHOLARSHIPS_FAILURE'

export const FETCH_HARDCOPY_SUBMISSIONS = 'growsmart/FETCH_HARDCOPY_SUBMISSIONS'
export const FETCH_HARDCOPY_SUBMISSIONS_SUCCESS = 'growsmart/FETCH_HARDCOPY_SUBMISSIONS_SUCCESS'
export const FETCH_HARDCOPY_SUBMISSIONS_FAILURE = 'growsmart/FETCH_HARDCOPY_SUBMISSIONS_FAILURE'

export const DELETE_SCHOLARSHIP = 'growsmart/DELETE_SCHOLARSHIP'
export const DELETE_SCHOLARSHIP_SUCCESS = 'growsmart/DELETE_SCHOLARSHIP_SUCCESS'
export const DELETE_SCHOLARSHIP_FAILURE = 'growsmart/DELETE_SCHOLARSHIP_FAILURE'

export const CREATE_SCHOLARSHIP = 'growsmart/CREATE_SCHOLARSHIP'
export const CREATE_SCHOLARSHIP_SUCCESS = 'growsmart/CREATE_SCHOLARSHIP_SUCCESS'
export const CREATE_SCHOLARSHIP_FAILURE = 'growsmart/CREATE_SCHOLARSHIP_FAILURE'

export const UPDATE_ENROLMENT = 'growsmart/UPDATE_ENROLMENT'
export const UPDATE_ENROLMENT_SUCCESS = 'growsmart/UPDATE_ENROLMENT_SUCCESS'
export const UPDATE_ENROLMENT_FAILURE = 'growsmart/UPDATE_ENROLMENT_FAILURE'
export const UPDATE_ENROLMENT_AS_PARENT = 'growsmart/UPDATE_ENROLMENT_AS_PARENT'
export const UPDATE_ENROLMENT_AS_PARENT_SUCCESS = 'growsmart/UPDATE_ENROLMENT_AS_PARENT_SUCCESS'
export const UPDATE_ENROLMENT_AS_PARENT_FAILURE = 'growsmart/UPDATE_ENROLMENT_AS_PARENT_FAILURE'

export const UPDATE_REGISTRATION = 'growsmart/UPDATE_REGISTRATION'
export const UPDATE_REGISTRATION_SUCCESS = 'growsmart/UPDATE_REGISTRATION_SUCCESS'
export const UPDATE_REGISTRATION_FAILURE = 'growsmart/UPDATE_REGISTRATION_FAILURE'

export const UPDATE_RSVP = 'growsmart/UPDATE_RSVP'
export const UPDATE_RSVP_SUCCESS = 'growsmart/UPDATE_RSVP_SUCCESS'
export const UPDATE_RSVP_FAILURE = 'growsmart/UPDATE_RSVP_FAILURE'

export const UPDATE_SCHOLARSHIP = 'growsmart/UPDATE_SCHOLARSHIP'
export const UPDATE_SCHOLARSHIP_SUCCESS = 'growsmart/UPDATE_SCHOLARSHIP_SUCCESS'
export const UPDATE_SCHOLARSHIP_FAILURE = 'growsmart/UPDATE_SCHOLARSHIP_FAILURE'

export const UPDATE_SCHOLARSHIP_APPLICATION = 'growsmart/UPDATE_SCHOLARSHIP_APPLICATION'
export const UPDATE_SCHOLARSHIP_APPLICATION_SUCCESS =
  'growsmart/UPDATE_SCHOLARSHIP_APPLICATION_SUCCESS'
export const UPDATE_SCHOLARSHIP_APPLICATION_FAILURE =
  'growsmart/UPDATE_SCHOLARSHIP_APPLICATION_FAILURE'

export const UPDATE_SPONSORSHIP = 'growsmart/UPDATE_SPONSORSHIP'
export const UPDATE_SPONSORSHIP_SUCCESS = 'growsmart/UPDATE_SPONSORSHIP_SUCCESS'
export const UPDATE_SPONSORSHIP_FAILURE = 'growsmart/UPDATE_SPONSORSHIP_FAILURE'

export const FETCH_SCHOLARSHIP_APPLICATION = 'growsmart/FETCH_SCHOLARSHIP_APPLICATION'
export const FETCH_SCHOLARSHIP_APPLICATION_SUCCESS =
  'growsmart/FETCH_SCHOLARSHIP_APPLICATION_SUCCESS'
export const FETCH_SCHOLARSHIP_APPLICATION_FAILURE =
  'growsmart/FETCH_SCHOLARSHIP_APPLICATION_FAILURE'

export const FETCH_SCHOLARSHIP_APPLICATIONS = 'growsmart/FETCH_SCHOLARSHIP_APPLICATIONS'
export const FETCH_SCHOLARSHIP_APPLICATIONS_SUCCESS =
  'growsmart/FETCH_SCHOLARSHIP_APPLICATIONS_SUCCESS'
export const FETCH_SCHOLARSHIP_APPLICATIONS_FAILURE =
  'growsmart/FETCH_SCHOLARSHIP_APPLICATIONS_FAILURE'

export const MANUAL_REGISTRATION = 'growsmart/MANUAL_REGISTRATION'
export const MANUAL_REGISTRATION_SUCCESS = 'growsmart/MANUAL_REGISTRATION_SUCCESS'
export const MANUAL_REGISTRATION_FAILURE = 'growsmart/MANUAL_REGISTRATION_FAILURE'

export const CLOSE_ROUND = 'growsmart/CLOSE_ROUND'
export const CLOSE_ROUND_SUCCESS = 'growsmart/CLOSE_ROUND_SUCCESS'
export const CLOSE_ROUND_FAILURE = 'growsmart/CLOSE_ROUND_FAILURE'

export const UPDATE_ROUND_MARKS = 'growsmart/UPDATE_ROUND_MARKS'
export const UPDATE_ROUND_MARKS_SUCCESS = 'growsmart/UPDATE_ROUND_MARKS_SUCCESS'
export const UPDATE_ROUND_MARKS_FAILURE = 'growsmart/UPDATE_ROUND_MARKS_FAILURE'

export const LAUNCH_COMP = 'growsmart/LAUNCH_COMP'
export const LAUNCH_COMP_SUCCESS = 'growsmart/LAUNCH_COMP_SUCCESS'
export const LAUNCH_COMP_FAILURE = 'growsmart/LAUNCH_COMP_FAILURE'

export const LOGOUT_SUCCESS = 'authentication/LOGOUT_SUCCESS'

export const {
  growsmart: {
    inviteMentor,
    inviteMentorSuccess,
    inviteMentorFailure,
    declineInvite,
    declineInviteSuccess,
    declineInviteFailure,
    fetchRegistrations,
    fetchRegistrationsSuccess,
    fetchRegistrationsFailure,
    fetchEnrolment,
    fetchEnrolmentSuccess,
    fetchEnrolmentFailure,
    fetchEnrolments,
    fetchEnrolmentsSuccess,
    fetchEnrolmentsFailure,
    fetchDistricts,
    fetchDistrictsSuccess,
    fetchDistrictsFailure,
    fetchRsvps,
    fetchRsvpsSuccess,
    fetchRsvpsFailure,
    fetchSchoolsForProvince,
    fetchSchoolsForProvinceSuccess,
    fetchSchoolsForProvinceFailure,
    fetchHardcopySubmissions,
    fetchHardcopySubmissionsSuccess,
    fetchHardcopySubmissionsFailure,
    bulkUpdateHardcopySubmissions,
    bulkUpdateHardcopySubmissionsSuccess,
    bulkUpdateHardcopySubmissionsFailure,
    bulkUpdateSchools,
    bulkUpdateSchoolsSuccess,
    bulkUpdateSchoolsFailure,
    updateRsvp,
    updateRsvpSuccess,
    updateRsvpFailure,
    updateEnrolment,
    updateEnrolmentSuccess,
    updateEnrolmentFailure,
    updateEnrolmentAsParent,
    updateEnrolmentAsParentSuccess,
    updateEnrolmentAsParentFailure,
    updateRegistration,
    updateRegistrationSuccess,
    updateRegistrationFailure,
    fetchSponsorship,
    fetchSponsorshipSuccess,
    fetchSponsorshipFailure,
    fetchSponsorships,
    fetchSponsorshipsSuccess,
    fetchSponsorshipsFailure,
    deleteSponsorship,
    deleteSponsorshipSuccess,
    deleteSponsorshipFailure,
    updateSponsorship,
    updateSponsorshipSuccess,
    updateSponsorshipFailure,
    createSponsorship,
    createSponsorshipSuccess,
    createSponsorshipFailure,
    fetchScholarship,
    fetchScholarshipSuccess,
    fetchScholarshipFailure,
    fetchScholarships,
    fetchScholarshipsSuccess,
    fetchScholarshipsFailure,
    deleteScholarship,
    deleteScholarshipSuccess,
    deleteScholarshipFailure,
    createScholarship,
    createScholarshipSuccess,
    createScholarshipFailure,
    updateScholarship,
    updateScholarshipSuccess,
    updateScholarshipFailure,
    manualRegistration,
    manualRegistrationSuccess,
    manualRegistrationFailure,
    closeRound,
    closeRoundSuccess,
    closeRoundFailure,
    updateRoundMarks,
    updateRoundMarksSuccess,
    updateRoundMarksFailure,
    launchComp,
    launchCompSuccess,
    launchCompFailure,
    fetchScholarshipApplication,
    fetchScholarshipApplicationFailure,
    fetchScholarshipApplicationSuccess,
    fetchScholarshipApplications,
    fetchScholarshipApplicationsFailure,
    fetchScholarshipApplicationsSuccess,
    updateScholarshipApplication,
    updateScholarshipApplicationFailure,
    updateScholarshipApplicationSuccess,
    applyToScholarship,
    applyToScholarshipFailure,
    applyToScholarshipSuccess
  }
} = createActions({
  [INVITE_MENTOR]: undefined,
  [INVITE_MENTOR_SUCCESS]: undefined,
  [INVITE_MENTOR_FAILURE]: undefined,
  [DECLINE_INVITE]: undefined,
  [DECLINE_INVITE_SUCCESS]: undefined,
  [DECLINE_INVITE_FAILURE]: undefined,
  [FETCH_REGISTRATIONS]: undefined,
  [FETCH_REGISTRATIONS_SUCCESS]: undefined,
  [FETCH_REGISTRATIONS_FAILURE]: undefined,
  [FETCH_ENROLMENTS]: undefined,
  [FETCH_ENROLMENT_SUCCESS]: undefined,
  [FETCH_ENROLMENT_FAILURE]: undefined,
  [FETCH_ENROLMENT]: undefined,
  [FETCH_ENROLMENTS_SUCCESS]: undefined,
  [FETCH_ENROLMENTS_FAILURE]: undefined,
  [FETCH_DISTRICTS]: undefined,
  [FETCH_DISTRICTS_SUCCESS]: undefined,
  [FETCH_DISTRICTS_FAILURE]: undefined,
  [FETCH_RSVPS]: undefined,
  [FETCH_RSVPS_SUCCESS]: undefined,
  [FETCH_RSVPS_FAILURE]: undefined,
  [FETCH_SCHOOLS_FOR_PROVINCE]: undefined,
  [FETCH_SCHOOLS_FOR_PROVINCE_SUCCESS]: undefined,
  [FETCH_SCHOOLS_FOR_PROVINCE_FAILURE]: undefined,
  [FETCH_HARDCOPY_SUBMISSIONS]: undefined,
  [FETCH_HARDCOPY_SUBMISSIONS_SUCCESS]: undefined,
  [FETCH_HARDCOPY_SUBMISSIONS_FAILURE]: undefined,
  [BULK_UPDATE_HARDCOPY_SUBMISSIONS]: undefined,
  [BULK_UPDATE_HARDCOPY_SUBMISSIONS_SUCCESS]: undefined,
  [BULK_UPDATE_HARDCOPY_SUBMISSIONS_FAILURE]: undefined,
  [BULK_UPDATE_SCHOOLS]: undefined,
  [BULK_UPDATE_SCHOOLS_SUCCESS]: undefined,
  [BULK_UPDATE_SCHOOLS_FAILURE]: undefined,
  [UPDATE_RSVP]: undefined,
  [UPDATE_RSVP_SUCCESS]: undefined,
  [UPDATE_RSVP_FAILURE]: undefined,
  [UPDATE_REGISTRATION]: undefined,
  [UPDATE_REGISTRATION_SUCCESS]: undefined,
  [UPDATE_REGISTRATION_FAILURE]: undefined,
  [FETCH_SPONSORSHIP]: undefined,
  [FETCH_SPONSORSHIP_SUCCESS]: undefined,
  [FETCH_SPONSORSHIP_FAILURE]: undefined,
  [FETCH_SPONSORSHIPS]: undefined,
  [FETCH_SPONSORSHIPS_SUCCESS]: undefined,
  [FETCH_SPONSORSHIPS_FAILURE]: undefined,
  [CREATE_SPONSORSHIP]: undefined,
  [CREATE_SPONSORSHIP_SUCCESS]: undefined,
  [CREATE_SPONSORSHIP_FAILURE]: undefined,
  [UPDATE_SPONSORSHIP]: undefined,
  [UPDATE_SPONSORSHIP_SUCCESS]: undefined,
  [UPDATE_SPONSORSHIP_FAILURE]: undefined,
  [DELETE_SPONSORSHIP]: undefined,
  [DELETE_SPONSORSHIP_SUCCESS]: undefined,
  [DELETE_SPONSORSHIP_FAILURE]: undefined,
  [FETCH_SCHOLARSHIP]: undefined,
  [FETCH_SCHOLARSHIP_SUCCESS]: undefined,
  [FETCH_SCHOLARSHIP_FAILURE]: undefined,
  [FETCH_SCHOLARSHIPS]: undefined,
  [FETCH_SCHOLARSHIPS_SUCCESS]: undefined,
  [FETCH_SCHOLARSHIPS_FAILURE]: undefined,
  [CREATE_SCHOLARSHIP]: undefined,
  [CREATE_SCHOLARSHIP_SUCCESS]: undefined,
  [CREATE_SCHOLARSHIP_FAILURE]: undefined,
  [UPDATE_SCHOLARSHIP]: undefined,
  [UPDATE_SCHOLARSHIP_SUCCESS]: undefined,
  [UPDATE_SCHOLARSHIP_FAILURE]: undefined,
  [MANUAL_REGISTRATION]: undefined,
  [MANUAL_REGISTRATION_SUCCESS]: undefined,
  [MANUAL_REGISTRATION_FAILURE]: undefined,
  [DELETE_SCHOLARSHIP]: undefined,
  [DELETE_SCHOLARSHIP_SUCCESS]: undefined,
  [DELETE_SCHOLARSHIP_FAILURE]: undefined,
  [FETCH_SCHOLARSHIP_APPLICATION]: undefined,
  [FETCH_SCHOLARSHIP_APPLICATION_FAILURE]: undefined,
  [FETCH_SCHOLARSHIP_APPLICATION_SUCCESS]: undefined,
  [FETCH_SCHOLARSHIP_APPLICATIONS]: undefined,
  [FETCH_SCHOLARSHIP_APPLICATIONS_FAILURE]: undefined,
  [FETCH_SCHOLARSHIP_APPLICATIONS_SUCCESS]: undefined,
  [UPDATE_SCHOLARSHIP_APPLICATION]: undefined,
  [UPDATE_SCHOLARSHIP_APPLICATION_FAILURE]: undefined,
  [UPDATE_SCHOLARSHIP_APPLICATION_SUCCESS]: undefined,
  [APPLY_TO_SCHOLARSHIP]: undefined,
  [APPLY_TO_SCHOLARSHIP_SUCCESS]: undefined,
  [APPLY_TO_SCHOLARSHIP_FAILURE]: undefined,
  [UPDATE_ENROLMENT]: undefined,
  [UPDATE_ENROLMENT_SUCCESS]: undefined,
  [UPDATE_ENROLMENT_FAILURE]: undefined,
  [UPDATE_ENROLMENT_AS_PARENT]: undefined,
  [UPDATE_ENROLMENT_AS_PARENT_SUCCESS]: undefined,
  [UPDATE_ENROLMENT_AS_PARENT_FAILURE]: undefined,
  [CLOSE_ROUND]: undefined,
  [CLOSE_ROUND_SUCCESS]: undefined,
  [CLOSE_ROUND_FAILURE]: undefined,
  [UPDATE_ROUND_MARKS]: undefined,
  [UPDATE_ROUND_MARKS_SUCCESS]: undefined,
  [UPDATE_ROUND_MARKS_FAILURE]: undefined,
  [LAUNCH_COMP]: undefined,
  [LAUNCH_COMP_SUCCESS]: undefined,
  [LAUNCH_COMP_FAILURE]: undefined
})

const initialPaginatedData = {
  enrolmentsPageCount: 0,
  enrolmentsCount: 0,
  enrolments: []
}

const initialState = {
  paginatedEnrolmentsData: initialPaginatedData,
  data: [],
  registrationsData: [],
  allSlots: [],
  siblingRounds: [],
  roundSlots: [],
  roundInQuestion: {},
  levelForRoundInQuestion: null,
  progressionsThisRound: null,
  isQuantitativeComp: true,
  isIndividualPerfComp: true,
  enrolmentData: {},
  rsvpsData: [],
  gsDistricts: [],
  schoolsForProvData: [],
  hardcopySubmissions: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  campLaunched: false,
  campLaunching: false,
  sponsorshipsData: [],
  singleSponsorshipData: {},
  singleScholarshipApplicationData: {},
  scholarshipsData: [],
  scholarshipApplicationsData: [],
  singleScholarshipData: {}
}

const updateSet = ({ set, payload, payloadId, recordUpdated, recordUpdating }) => {
  if (payload.wasMoved) {
    return set.filter(r => !idsMatch(payloadId, r.id))
  }

  return set.map(r => {
    if (!idsMatch(payloadId, r.id)) return r

    const {
      wasMoved,
      meta,
      status,
      gender,
      grade,
      race,
      f_name,
      l_name,
      parent_email,
      parent_mobile_number,
      avg_mark_prev_year,
      avg_mark_mid_comp,
      avg_mark_post_comp,
      avg_mark_prev_year_report,
      avg_mark_mid_comp_report,
      avg_mark_post_comp_report
    } = payload
    const updatedRecord = { ...r, recordUpdated, recordUpdating, wasMoved }

    if (f_name) {
      updatedRecord.learner_f_name = f_name
    }

    if (l_name) {
      updatedRecord.learner_l_name = l_name
    }

    if (gender) {
      updatedRecord.gender = gender
    }

    if (grade) {
      updatedRecord.grade = grade
    }

    if (race) {
      updatedRecord.race = race
    }

    if (
      meta ||
      parent_mobile_number ||
      parent_email ||
      avg_mark_prev_year ||
      avg_mark_mid_comp ||
      avg_mark_post_comp ||
      avg_mark_prev_year_report ||
      avg_mark_mid_comp_report ||
      avg_mark_post_comp_report
    ) {
      updatedRecord.meta = {
        ...meta,
        parent_email,
        parent_mobile_number,
        avg_mark_prev_year,
        avg_mark_mid_comp,
        avg_mark_post_comp,
        avg_mark_prev_year_report,
        avg_mark_mid_comp_report,
        avg_mark_post_comp_report
      }
    }

    if (avg_mark_prev_year_report) {
      const isRealFile = typeof avg_mark_prev_year_report !== 'string'
      updatedRecord.prevReportUploaded = isRealFile
    }

    if (avg_mark_mid_comp_report) {
      const isRealFile = typeof avg_mark_mid_comp_report !== 'string'
      updatedRecord.midReportUploaded = isRealFile
    }

    if (avg_mark_post_comp_report) {
      const isRealFile = typeof avg_mark_post_comp_report !== 'string'
      updatedRecord.postReportUploaded = isRealFile
    }

    if (status) {
      updatedRecord.status = status
    }

    return updatedRecord
  })
}

export default handleActions(
  {
    [INVITE_MENTOR]: state => ({
      ...state,
      isLoading: true,
      isSubmitting: true
    }),
    [INVITE_MENTOR_SUCCESS]: (state, { payload }) => ({
      ...state,
      data: payload,
      isLoading: false,
      isError: false,
      isSubmitting: false
    }),
    [INVITE_MENTOR_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: false,
      isError: true
    }),
    [DECLINE_INVITE]: state => ({
      ...state,
      isLoading: true
    }),
    [DECLINE_INVITE_SUCCESS]: (state, { payload }) => ({
      ...state,
      data: payload,
      isLoading: false,
      isError: false
    }),
    [DECLINE_INVITE_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true
    }),
    [FETCH_REGISTRATIONS]: state => ({
      ...state,
      isLoading: true
    }),
    [FETCH_REGISTRATIONS_SUCCESS]: (state, { payload }) => ({
      ...state,
      registrationsData: payload.registrations,
      allSlots: payload.allSlots,
      siblingRounds: payload.siblingRounds,
      roundSlots: payload.roundSlots,
      roundInQuestion: payload.roundInQuestion,
      levelForRoundInQuestion: payload.levelForRoundInQuestion,
      progressionsThisRound: payload.progressionsThisRound,
      isQuantitativeComp: payload.isQuantitativeComp,
      isIndividualPerfComp: payload.isIndividualPerfComp,
      enrolmentsPerRegistration: payload.enrolmentsPerRegistration,
      roundDistrictIds: payload.roundDistrictIds,
      isLoading: false,
      isError: false
    }),
    [FETCH_REGISTRATIONS_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true
    }),
    [FETCH_ENROLMENT]: state => ({
      ...state,
      isLoading: true
    }),
    [FETCH_ENROLMENT_SUCCESS]: (state, { payload }) => ({
      ...state,
      enrolmentData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_ENROLMENT_FAILURE]: state => ({
      ...state,
      isLoading: false,
      // do not show error so scrapers won't be able to bruteforce tokens
      isError: false
    }),
    [FETCH_ENROLMENTS]: state => ({
      ...state,
      isLoading: true
    }),
    [FETCH_ENROLMENTS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        loadWasSuccess: true,
        errorMessage: null
      }

      newState.paginatedEnrolmentsData.enrolmentsPageCount =
        payload.enrolmentsPageCount || payload.pageCount || 0
      newState.paginatedEnrolmentsData.enrolmentsCount = payload.enrolmentsCount || 0
      newState.paginatedEnrolmentsData.enrolments = payload.enrolments || []

      return newState
    },
    [FETCH_ENROLMENTS_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true
    }),
    [FETCH_SCHOOLS_FOR_PROVINCE]: state => ({
      ...state,
      isLoading: true
    }),
    [FETCH_SCHOOLS_FOR_PROVINCE_SUCCESS]: (state, { payload }) => ({
      ...state,
      schoolsForProvData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_SCHOOLS_FOR_PROVINCE_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true
    }),
    [FETCH_HARDCOPY_SUBMISSIONS]: state => ({
      ...state,
      isLoading: true
    }),
    [FETCH_HARDCOPY_SUBMISSIONS_SUCCESS]: (state, { payload }) => ({
      ...state,
      hardcopySubmissions: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_HARDCOPY_SUBMISSIONS_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true
    }),
    [BULK_UPDATE_HARDCOPY_SUBMISSIONS]: state => ({
      ...state,
      isLoading: true
    }),
    [BULK_UPDATE_HARDCOPY_SUBMISSIONS_SUCCESS]: state => ({
      ...state,
      isLoading: false,
      isError: false
    }),
    [BULK_UPDATE_HARDCOPY_SUBMISSIONS_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true
    }),
    [BULK_UPDATE_SCHOOLS]: state => ({
      ...state,
      isLoading: true
    }),
    [BULK_UPDATE_SCHOOLS_SUCCESS]: state => ({
      ...state,
      isLoading: false,
      isError: false
    }),
    [BULK_UPDATE_SCHOOLS_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true
    }),
    [FETCH_RSVPS]: state => ({
      ...state,
      isLoading: true
    }),
    [FETCH_RSVPS_SUCCESS]: (state, { payload }) => ({
      ...state,
      rsvpsData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_RSVPS_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true
    }),
    [FETCH_DISTRICTS]: state => ({
      ...state,
      isLoading: true
    }),
    [FETCH_DISTRICTS_SUCCESS]: (state, { payload }) => ({
      ...state,
      gsDistricts: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_DISTRICTS_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true
    }),
    [UPDATE_RSVP]: (state, { payload }) => {
      const set = state.rsvpsData
      const payloadId = payload.id
      const recordUpdated = false
      const recordUpdating = true
      const updatedData = updateSet({ set, payload, payloadId, recordUpdated, recordUpdating })

      return {
        ...state,
        isLoading: false,
        isSubmitting: true,
        rsvpsData: updatedData
      }
    },
    [UPDATE_RSVP_SUCCESS]: (state, { payload }) => {
      const set = state.rsvpsData
      const payloadId = payload.id
      const recordUpdated = true
      const recordUpdating = false
      const updatedData = updateSet({ set, payload, payloadId, recordUpdated, recordUpdating })

      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        rsvpsData: updatedData
      }
    },
    [UPDATE_RSVP_FAILURE]: (state, payload) => ({
      ...state,
      ...payload,
      isLoading: false,
      isSubmitting: false
    }),
    [UPDATE_REGISTRATION]: (state, { payload }) => {
      const set = state.registrationsData
      const payloadId = payload.id
      const recordUpdated = false
      const recordUpdating = true
      const updatedData = updateSet({ set, payload, payloadId, recordUpdated, recordUpdating })

      return {
        ...state,
        isLoading: false,
        isSubmitting: true,
        registrationsData: updatedData
      }
    },
    [UPDATE_REGISTRATION_SUCCESS]: (state, { payload }) => {
      const set = state.registrationsData
      const payloadId = payload.id
      const recordUpdated = true
      const recordUpdating = false
      const updatedData = updateSet({ set, payload, payloadId, recordUpdated, recordUpdating })

      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        registrationsData: updatedData
      }
    },
    [UPDATE_REGISTRATION_FAILURE]: (state, payload) => ({
      ...state,
      ...payload,
      isLoading: false,
      isSubmitting: false
    }),
    [FETCH_SPONSORSHIPS]: state => ({
      ...state,
      isLoading: true
    }),
    [FETCH_SPONSORSHIPS_SUCCESS]: (state, { payload }) => ({
      ...state,
      sponsorshipsData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_SPONSORSHIPS_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true
    }),
    [FETCH_SPONSORSHIP]: state => ({
      ...state,
      isLoading: true
    }),
    [FETCH_SPONSORSHIP_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleSponsorshipData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_SPONSORSHIP_FAILURE]: state => ({ ...state, isLoading: false, isError: false }),
    [CREATE_SPONSORSHIP]: state => ({ ...state, isLoading: false, isSubmitting: true }),
    [CREATE_SPONSORSHIP_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        errorMessage: null,
        payload: {},
        singleSponsorshipData: payload.data
      }
    },
    [CREATE_SPONSORSHIP_FAILURE]: state => ({
      ...state,
      singleSponsorshipData: {},
      isLoading: false,
      isSubmitting: false
    }),
    [DELETE_SPONSORSHIP]: (state, { payload }) => ({
      ...state,
      isLoading: true,
      hasSubmitted: true,
      sponsorshipId: payload
    }),
    [DELETE_SPONSORSHIP_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        hasSubmitted: true,
        sponsorshipsData: state.sponsorshipsData.filter(o => o.id !== payload.id),
        opportunityId: null
      }
    },
    [DELETE_SPONSORSHIP_FAILURE]: state => ({
      ...state,
      isLoading: false,
      hasSubmitted: true,
      sponsorshipId: null
    }),
    [UPDATE_SPONSORSHIP]: (state, { payload }) => {
      const set = state.sponsorshipsData
      const payloadId = payload.id
      const recordUpdated = false
      const recordUpdating = true
      const updatedData = updateSet({ set, payload, payloadId, recordUpdated, recordUpdating })

      return {
        ...state,
        isSuccess: false,
        isLoading: false,
        isSubmitting: true,
        sponsorshipsData: updatedData
      }
    },
    [UPDATE_SPONSORSHIP_SUCCESS]: (state, { payload }) => {
      const updatedData = state.sponsorshipsData.map(r => {
        if (!idsMatch(payload.id, r.id)) return r
        return { ...r, status: payload.status }
      })

      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true,
        sponsorshipsData: updatedData
      }
    },
    [UPDATE_SPONSORSHIP_FAILURE]: (state, payload) => ({
      ...state,
      ...payload,
      isLoading: false,
      isSubmitting: false,
      isSuccess: false
    }),
    [FETCH_SCHOLARSHIPS]: state => ({
      ...state,
      isLoading: true
    }),
    [FETCH_SCHOLARSHIPS_SUCCESS]: (state, { payload }) => ({
      ...state,
      scholarshipsData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_SCHOLARSHIPS_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true
    }),
    [FETCH_SCHOLARSHIP]: state => ({
      ...state,
      isLoading: true
    }),
    [FETCH_SCHOLARSHIP_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleScholarshipData: payload,
      isLoading: false,
      isError: false
    }),
    [FETCH_SCHOLARSHIP_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: false
    }),
    [DELETE_SCHOLARSHIP]: (state, { payload }) => ({
      ...state,
      isLoading: true,
      hasSubmitted: true,
      scholarshipId: payload
    }),
    [DELETE_SCHOLARSHIP_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        hasSubmitted: true,
        scholarshipsData: state.scholarshipsData.filter(o => o.id !== payload.id),
        scholarshipId: null
      }
    },
    [DELETE_SCHOLARSHIP_FAILURE]: state => ({
      ...state,
      isLoading: false,
      hasSubmitted: true,
      scholarshipId: null
    }),
    [CREATE_SCHOLARSHIP]: state => ({ ...state, isLoading: false, isSubmitting: true }),
    [CREATE_SCHOLARSHIP_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        errorMessage: null,
        payload: {},
        singleScholarshipData: payload.data
      }
    },
    [CREATE_SCHOLARSHIP_FAILURE]: state => ({
      ...state,
      singleScholarshipData: {},
      isLoading: false,
      isSubmitting: false
    }),
    [APPLY_TO_SCHOLARSHIP]: state => ({ ...state, isLoading: false, isSubmitting: true }),
    [APPLY_TO_SCHOLARSHIP_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        errorMessage: null,
        payload: {},
        scholarshipApplicationsData: payload.data
      }
    },
    [APPLY_TO_SCHOLARSHIP_FAILURE]: state => ({
      ...state,
      singleScholarshipApplicationData: {},
      isLoading: false,
      isSubmitting: false
    }),
    [UPDATE_SCHOLARSHIP_APPLICATION]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: true
    }),
    [UPDATE_SCHOLARSHIP_APPLICATION_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: false
    }),
    [UPDATE_SCHOLARSHIP_APPLICATION_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        errorMessage: null,
        singleScholarshipApplicationData: payload
      }
    },
    [FETCH_SCHOLARSHIP_APPLICATION]: state => ({ ...state, isLoading: true, isSubmitting: false }),
    [FETCH_SCHOLARSHIP_APPLICATION_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        errorMessage: null,
        singleScholarshipApplicationData: payload
      }
    },
    [FETCH_SCHOLARSHIP_APPLICATION_FAILURE]: state => ({
      ...state,
      singleScholarshipApplicationData: {},
      isLoading: false,
      isSubmitting: false
    }),
    [FETCH_SCHOLARSHIP_APPLICATIONS]: state => ({ ...state, isLoading: false, isSubmitting: true }),
    [FETCH_SCHOLARSHIP_APPLICATIONS_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        errorMessage: null,
        scholarshipApplicationsData: payload.scholarshipApplicationsData,
        singleScholarshipData: payload.scholarshipData
      }
    },
    [FETCH_SCHOLARSHIP_APPLICATIONS_FAILURE]: state => ({
      ...state,
      scholarshipApplicationsData: [],
      isLoading: false,
      isSubmitting: false
    }),
    [MANUAL_REGISTRATION]: state => {
      return {
        ...state,
        isSuccess: false,
        isLoading: false,
        isSubmitting: true
      }
    },
    [MANUAL_REGISTRATION_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    },
    [MANUAL_REGISTRATION_FAILURE]: state => ({
      ...state,
      errorMessage: 'Something went wrong',
      isLoading: false,
      isSubmitting: false,
      isSuccess: false
    }),
    [UPDATE_SCHOLARSHIP]: (state, { payload }) => {
      const set = state.scholarshipsData
      const payloadId = payload.id
      const recordUpdated = false
      const recordUpdating = true
      const updatedData = updateSet({ set, payload, payloadId, recordUpdated, recordUpdating })

      return {
        ...state,
        isSuccess: false,
        isLoading: false,
        isSubmitting: true,
        scholarshipsData: updatedData
      }
    },
    [UPDATE_SCHOLARSHIP_SUCCESS]: (state, { payload }) => {
      const updatedData = state.scholarshipsData.map(r => {
        if (!idsMatch(payload.id, r.id)) return r
        return { ...r, status: payload.status }
      })

      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true,
        scholarshipsData: updatedData
      }
    },
    [UPDATE_SCHOLARSHIP_FAILURE]: (state, payload) => ({
      ...state,
      ...payload,
      isLoading: false,
      isSubmitting: false,
      isSuccess: false
    }),
    [UPDATE_ENROLMENT]: (state, { payload }) => {
      const set = state.enrolmentsData || []
      const payloadId = payload.id
      const recordUpdated = false
      const recordUpdating = true
      const updatedData = updateSet({ set, payload, payloadId, recordUpdated, recordUpdating })

      return {
        ...state,
        isSuccess: false,
        isLoading: false,
        isSubmitting: true,
        enrolmentsData: updatedData
      }
    },
    [UPDATE_ENROLMENT_SUCCESS]: (state, { payload }) => {
      const updatedData = state.enrolmentsData.map(r => {
        if (!idsMatch(payload.id, r.id)) return r
        return { ...r, status: payload.status }
      })

      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true,
        enrolmentsData: updatedData
      }
    },
    [UPDATE_ENROLMENT_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.message,
      isLoading: false,
      isSubmitting: false,
      isSuccess: false
    }),
    [UPDATE_ENROLMENT_AS_PARENT]: (state, { payload }) => ({
      ...state,
      isSuccess: false,
      isLoading: false,
      isSubmitting: true,
      enrolmentData: payload
    }),
    [UPDATE_ENROLMENT_AS_PARENT_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isSubmitting: false,
      isSuccess: true,
      enrolmentData: payload
    }),
    [UPDATE_ENROLMENT_AS_PARENT_FAILURE]: (state, payload) => ({
      ...state,
      ...payload,
      isLoading: false,
      isSubmitting: false,
      isSuccess: false
    }),
    [CLOSE_ROUND]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: true
    }),
    [CLOSE_ROUND_SUCCESS]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: true
    }),
    [CLOSE_ROUND_FAILURE]: (state, payload) => ({
      ...state,
      ...payload,
      isLoading: false,
      isSubmitting: false
    }),
    [UPDATE_ROUND_MARKS]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: true
    }),
    [UPDATE_ROUND_MARKS_SUCCESS]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: true
    }),
    [UPDATE_ROUND_MARKS_FAILURE]: (state, payload) => ({
      ...state,
      ...payload,
      isLoading: false,
      isSubmitting: false
    }),
    [LAUNCH_COMP]: state => ({
      ...state,
      campLaunching: true,
      campLaunched: false
    }),
    [LAUNCH_COMP_SUCCESS]: state => ({
      ...state,
      campLaunching: false,
      campLaunched: true
    }),
    [LAUNCH_COMP_FAILURE]: state => ({
      ...state,
      campLaunching: false,
      campLaunched: false
    }),
    [LOGOUT_SUCCESS]: () => initialState
  },
  initialState
)
